import { P } from "./catalogo-ui";
import { eqText } from "@/engine/excel/fns";

/** Veces al año de una modalidad (vacía o fuera de menú = 1, como el Excel). */
export const vecesAlAnio = (m: string | null) => P.modalities.find((x) => eqText(x.name, m))?.perYear ?? 1;
export const anual = (monto: number | null, m: string | null) => (monto ?? 0) * vecesAlAnio(m);
const f = new Intl.NumberFormat("en-US", { maximumFractionDigits: 0 });
export const dinero = (v: number | null, cur = "MXN") => (v === null || !Number.isFinite(v) ? "—" : `${f.format(v)} ${cur}`);
